import { tv } from '~/utils/tv'

export const inputTextLabelVariants = tv({
  base: `
      w-[100%] align-middle m-none p-none
      text-left font-rdmodern font-regular tracking-tiny text-text-neutral text-nowrap truncate leading

      `,
  variants: {
    size: {
      md: 'text-threepulse',
      ml: 'text-threeandhalfpulse',
      lg: 'text-threeandhalfpulse',
      xl: 'text-threeandhalfpulse',
    },

    readOnly: {
      true: '',
      false: '',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'cursor-not-allowed text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    disabled: false,
    readOnly: false,
  },
})
